import { useTranslation } from "react-i18next";
import { systemLabelKey } from "../../catalogs/characterSystemCatalog";
import { useCharacterAvatarSource } from "../../hooks/useCharacterAvatarSource";

const CharacterCard = ({ character, isActive, onDelete, onOpen, token }) => {
  const { t } = useTranslation();
  const avatarSource = useCharacterAvatarSource(character.avatarUrl, token);
  const classSummary =
    character.characterClass
      ?.filter((characterClass) => characterClass.id)
      .map((characterClass) => `${t(systemLabelKey("classes", characterClass.id))}${characterClass.classLevel ? ` ${characterClass.classLevel}` : ""}`)
      .join(" / ") || t("characters.noClass");
  const characterName = character.characterName || t("characters.unnamed");

  return (
    <div className="character-card-shell">
    <button
      aria-label={t("characters.openCharacter", { name: characterName })}
      className={`character-card${isActive ? " character-card--active" : ""}`}
      type="button"
      onClick={onOpen}
    >
      <div className="character-card-avatar">
        {avatarSource ? (
          <img alt="" src={avatarSource} />
        ) : (
          <span>{character.characterName?.charAt(0) || "?"}</span>
        )}
      </div>

      <div className="character-card-body">
        <div className="character-card-title">
          <h2>{characterName}</h2>
          {isActive && <span>{t("characters.active")}</span>}
        </div>
        <p className="character-card-class">
          {character.race?.id ? t(systemLabelKey("races", character.race.id)) : t("characters.noRace")} · {classSummary}
        </p>
        <div className="character-card-details">
          <span>{t("characters.level", { level: character.level?.level || 0 })}</span>
          <span>{character.alignmentId ? t(systemLabelKey("alignments", character.alignmentId)) : t("characters.noAlignment")}</span>
        </div>
        <p className="character-card-background">
          {character.background || t("characters.noBackground")}
        </p>
      </div>

      <span className="character-card-open">{t("characters.openSheet")}</span>
    </button>
      <button
        aria-label={t("characters.deleteCharacter", { name: characterName })}
        className="character-card-delete"
        title={t("characters.delete")}
        type="button"
        onClick={() => onDelete(character)}
      >
        &times;
      </button>
    </div>
  );
};

export default CharacterCard;
